<template>
  <div class="index-wrapper">
      <FormTemplate title="Large Enterprise Options">
        <template #main>
          <div class="wrapper">
          <div class="cost">$<span class="red price">{{ costEstimate }}</span> estimated monthly expense</div>
          <form>  
              <div class="row-item">
                <input type="checkbox" id="email" v-model="email.status" class="form-checkbox text-red-600">
                <label for="email">Are you looking for managed email solutions?</label>
              </div>
                <div v-if="email.status" class="sub-section-1">
                  <div class="row-item">
                    <input type="checkbox" id="office365" v-model="email.office365.status" class="form-checkbox text-red-600">
                    <label for="office365">Office 365</label>
                  </div>
                    <div v-if="email.office365.status" class="sub-section-2 row-item">
                        <input id="office365-users" type="number" v-model.number="email.office365.users">
                        <label class="no-pad" for="office365-users">users</label>
                    </div>
                  <div class="row-item">
                    <input type="checkbox" id="gateway" v-model="email.gateway.status" class="form-checkbox text-red-600">
                    <label for="gateway">Email Gateway</label>
                  </div>
                    <div v-if="email.gateway.status" class="sub-section-2 row-item">
                      <input id="gateway-users" type="number" v-model.number="email.gateway.users">
                      <label class="no-pad" for="gateway-users">users</label>
                    </div>
                </div>
              <div class="row-item">
                <input type="checkbox" id="managed" v-model="hosting.status" class="form-checkbox text-red-600">
                <label for="managed">Are you looking for managed hosting solutions?</label>
              </div>
                <div v-if="hosting.status" class="sub-section-1">
                  <div class="row-item">
                    <input type="checkbox" id="servers" v-model="hosting.cloudServers.status" class="form-checkbox text-red-600">
                    <label for="servers">Cloud Servers</label>
                  </div>
                    <div v-if="hosting.cloudServers.status" class="sub-section-2">
                      <div class="row-item">
                        <input type="checkbox" id="linux" v-model="hosting.cloudServers.linux" class="form-checkbox text-red-600">
                        <label for="linux">Linux</label>
                      </div>
                      <div class="row-item">
                          <input type="checkbox" id="windows" v-model="hosting.cloudServers.windows" class="form-checkbox text-red-600">
                          <label for="windows">Windows</label>
                      </div>
                    </div>
                  <div class="row-item">
                    <input type="checkbox" id="backup" v-model="hosting.managedBackup.status" class="form-checkbox text-red-600">
                    <label for="backup">Managed Backup</label>
                  </div>
                      <div v-if="hosting.managedBackup.status" class="sub-section-2 row-item">
                        <input id="gb" type="number" v-model.number="hosting.managedBackup.gb">
                        <label class="no-pad" for="gb">gigabits</label>
                      </div>
                  <div class="row-item">
                    <input type="checkbox" id="vpn" v-model="hosting.managedVPN.status" class="form-checkbox text-red-600">
                    <label for="vpn">Managed VPN</label>
                  </div>
                    <div v-if="hosting.managedVPN.status" class="sub-section-2 row-item">
                      <input id ="vpn-users" type="number" v-model.number="hosting.managedVPN.users">
                      <label class="no-pad" for="vpn-users">users</label>
                    </div>
                </div>
              <div class="row-item">
                <input type="checkbox" id="onpremise" v-model="onPremise.status" class="form-checkbox text-red-600">
                <label for="onpremise">Are you looking for managed on-premise solutions? <span class="red">*</span></label>
              </div>
                <div v-if="onPremise.status" class="sub-section-1">
                  <div class="row-item">
                    <input type="checkbox" id="premise-backup" v-model="onPremise.backup" class="form-checkbox text-red-600">
                    <label for="premise-backup">Backup</label>
                  </div>
                    <div v-if="onPremise.backup">
                      <textarea class="form-input block w-full"  placeholder="Can you tell us a bit more about how we can help you?" type="text" id="backup-info" v-model="onPremise.backupNotes"></textarea>
                    </div>
                  
                  <div class="row-item">
                    <input type="checkbox" id="premise-monitoring" v-model="onPremise.monitoring" class="form-checkbox text-red-600">
                    <label for="premise-monitoring">Monitoring</label>
                  </div>
                    <div v-if="onPremise.monitoring">
                      <textarea class="form-input block w-full"  placeholder="Can you tell us a bit more about how we can help you?" type="text" id="backup-info" v-model="onPremise.monitoringNotes"></textarea>
                    </div>
                </div>
            <button class="button-red">Submit Request</button>
          </form>
          </div>
        </template>
      </FormTemplate>
      <div class="note"><span class="red">*</span> options not included in pricing estimate</div>
  </div>
</template>

<script>
import FormTemplate from "../shared/FormTemplate";

export default {
  name: "LargeEnterprise",
  components: {
    FormTemplate
  },
  data() {
    return {
      email: {
        status: false,
        office365: {
          status: false,
          users: 0
        },
        gateway: {
          status: false,
          users: 0
        }
      },
      hosting: {
        status: false,
        cloudServers: {
          status: false,
          linux: false,
          windows: false
        },
        managedBackup: {
          status: false,
          gb: 0
        },
        managedVPN: {
          status: false,
          users: 0
        }
      },
      onPremise: {
        status: false,
        backup: false,
        backupNotes: "",
        monitoring: false,
        monitoringNotes: ""
      },
      costs: {
        office365: 10,
        emailGateway: 5,
        cloudServerLinux: 10,
        cloudServerWindows: 15,
        managedBackup: 1,
        managedVPN: 7,
        onPremiseBackup: 50,
        onPremiseMonitoring: 80
      }
    };
  },
  computed: {
    costEstimate: function() {
      let { costs, email, hosting, onPremise } = this;
      let result =
        costs.office365 * email.office365.users +
        costs.emailGateway * email.gateway.users +
        costs.managedBackup * hosting.managedBackup.gb +
        costs.managedVPN * hosting.managedVPN.users;
      if (hosting.cloudServers.linux) result += costs.cloudServerLinux;
      if (hosting.cloudServers.windows) result += costs.cloudServerWindows;
      if (onPremise.backup) result += costs.onPremiseBackup;
      if (onPremise.monitoring) result += costs.onPremiseMonitoring;
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.index-wrapper {
  padding: 30px 10%;
}
.cost {
  margin-bottom: 10px;
}
.red {
  color: #e53e3e;
}
.price {
  font-size: 1.3rem;
}
.wrapper {
  font-size: 1.2rem;
  background: #ffffff;
  padding: 20px;
  border-radius: 3px;
  margin-top: 10px;
}
.row-item {
  padding: 5px 0;
}
.sub-section-1 {
  padding-left: 20px;
  font-size: 1rem;
}
.section-2 {
  padding: 5px 0;
}
.sub-section-2 {
  padding-left: 20px;
}
.button-red {
  background: #e53e3e;
  color: #ffffff;
  font-size: 1rem;
  padding: 8px 12px;
  border-radius: 0.25rem;
  margin-top: 30px;
}
textarea {
  padding: 10px;
  height: 200px;
  margin: 5px 0;
}
input[type="number"] {
  padding: 0 5px;
  width: 80px;
  text-align: center;
}

label {
  padding-left: 10px;
}

.no-pad {
  padding: 0;
}
.note {
  font-size: 0.8rem;
}
</style>
